<template>
    <div class="panel">
        <div :class="[
            'panel__header position--relative display--flex',
            headerClass
        ]">
            <slot name="panel__header" />
            <button-with-icon
                v-if="close.show"
                :icon="{
                    component: () => import( /* webpackChunkName: 'IconCloseBig' */ '@/components/bundles/layout/images/icons/IconCloseBig' )
                }"
                class="panel__header__close position--absolute"
                :action="{
                    execute: true,
                    function: close.action
                }"
            />
        </div>
        <warning-bar
            v-if="data.contactRequest.warnings && data.contactRequest.warnings.taxpayerIdentificationNumber"
            class="gocc__warning"
            :settings="{
                status: 'insuccess',
                message: data.contactRequest.warnings.taxpayerIdentificationNumber
            }"
        />
        <div class="panel--grid display--grid">
            <accordion
                class="panel__card"
                v-bind="{
                    ...( data.contactRequest && {
                        contact: {
                            person: data.contactRequest.internalPersonProfile,
                            request: data.contactRequest.request,
                            requestObservations: data.contactRequest.observations,
                            internalObservations: data.contactRequest.internalObservations,
                            receptionDate: data.contactRequest.receptionDate,
                            callHistory: data.contactRequest.callHistory
                                ? data.contactRequest.callHistory
                                : data.contactRequest.contactCallHistory
                        }
                    }),
                    ...allowFilling
                }"
            />
            <base-script
                class="panel__card"
                v-bind="{
                    script: data.script,
                    ...allowFilling,
                    ...( !specificData.isOperateMenu && {
                        isOperateMenu: specificData.isOperateMenu
                    })
                }"
            />
        </div>
    </div>
</template>

<script>
// packages
import { computed } from '@vue/composition-api';

export default {
    components: {
        ButtonWithIcon: () => import( /* webpackChunkName: 'ButtonWithIcon' */ '@/components/bundles/buttons/BaseButtonWithIcon' ),
        BaseScript: () => import( /* webpackChunkName: 'BaseScript' */ '@/components/bundles/script/Script' ),
        Accordion: () => import( /* webpackChunkName: 'Accordion' */ '@/components/bundles/accordion/Accordion' ),
        WarningBar: () => import( /* webpackChunkName: 'WarningBar' */ '@/components/bundles/bars/warning/WarningBar' )
    },
    props: {
        headerClass: String,
        data: Object,
        specificData: {
            type: Object,
            default: () => ({})
        },
        close: {
            type: Object,
            default: () => ({ show: true, action: null })
        }
    },
    setup ({ specificData }) {
        const allowFilling = computed( () => ({
            ...( !specificData.allowFilling && {
                allowFilling: specificData.allowFilling
            })
        }) );

        return { allowFilling };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Variables
    // =============================================================================
    $small-col: 48.57%;
    $col-gap: 15px;
    $width-small-col: calc( #{$small-col} - #{$col-gap} );

    // =============================================================================
    // Style
    // =============================================================================
    .gocc {
        &__warning {
            margin-bottom: 20px;
        }
    }
    .panel {
        max-width: 1738px;
        width: 100%;
        padding: 100px 30px 0;
        margin: 0 auto;
        &--grid {
            grid-template-columns:
                $width-small-col
                calc( 100% - 48.57% - 15px );
            grid-gap: 30px;
            padding-bottom: 20px;
            @include responsive( max-width,  1380px ) {
                gap: 20px;
            }
        }
        &__header {
            justify-content: center;
            min-height: 35px;
            &__close {
                @include transform-position( 0, 0, false, false );
                .line {
                    @include transition( stroke .3s ease-in-out );
                    will-change: stroke;
                }
                &:hover {
                    .line {
                        stroke: $color-red;
                    }
                }
            }
        }
        &__card {
            height: 722px;
            overflow-y: auto;
        }
    }
</style>